// Copyright © 2022 Olo Inc. All rights reserved.
// This software is made available under the Olo Pay SDK License (See LICENSE.md file)
import { Platform, StyleSheet } from 'react-native';
import { FontWeight } from '../../definitions';

export const sharedComponentStyles = {
  defaultStyles: {
    borderWidth: 1,
    borderColor: '#BDBCBC',
    backgroundColor: '#FFFFFF',
    cardElevation: 1,
    cornerRadius: 5,
    cursorColor: '#9E9E9E',
    dividerColor: `#BDBCBC`,
    dividerWidth: 1,
    errorTextColor: '#C42D32',
    fontSize: 16,
    fontWeight: FontWeight.regular,
    italic: false,
    paddingLeft: 8,
    paddingRight: 0,
    placeholderColor: '#9E9E9E',
    focusedPlaceholderColor: '9E9E9E',
    textColor: '#141414',
    ...Platform.select({
      android: {
        fontFamily: 'Roboto',
      },
      ios: {
        fontFamily: 'San Francisco',
      },
    }),
  },
};

export const sharedErrorStyles = StyleSheet.create({
  defaultStyles: {
    minHeight: 20,
    textAlign: 'center',
    color: '#C42D32',
  },
});
